import React,{useState, useEffect}  from 'react';
import Sides from '../Bars/Csidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Cshortkeys()
{

    const [padding, setWindowpadding] = useState(0);
    const [width, setWindowWidth] = useState(0);
    useEffect(() => {
      updateDimensions()
  
      window.addEventListener('resize', updateDimensions)
      return () => window.removeEventListener('resize', updateDimensions)
    }, [])
  
    const updateDimensions = () => {
      const width = window.innerWidth
      setWindowWidth(width)
      if (width < 998) {
        setWindowpadding(2.5)
      } else {
        setWindowpadding(14)
      }
    }
  
    
    const right = {
      padding: '0 0 0 '+padding+'rem',
    };
return(
    <div>
             <Sides/>
             <Helmet>
 
 <title>Shortcut keys in c tutorial For Beginners</title>
 <meta name="description" content="shortcut keys in c tutorial for beginners.These Keyboard Shortcut Keys in C programming used inside turbo C,C++ mainly,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,learn code in free,c programming tutorial for beginners,learn code in free online,c language shortcut keys,turbo c shortcut keys,shortcut keys in c,shortcut key of c,c short cut keys" />
 <link rel="canonical" href="https://www.codeexampler.com/c-short-cut-keys" />
 </Helmet>

 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">Shortcut keys in c programming</h1><br/>
    <div className="first">
        <a href="/c-identifier">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/c-first-program">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
<h2 className="mt-4 mh2">These Keyboard Shortcut Keys in C programming Use inside turbo C, C++ mainly.</h2><br/>
<h5 className="mt-4 mx-4">1. Compile a programme – Alt+F9 (use getch();)<br/>
2. Run a program – Ctrl+F9<br/>
3. Save – F2<br/>
4. Open F3<br/>
5. Output view-Alt+F9<br/>
6, Open file - Alt+F<br/>
7, Exit-Alt+X<br/>
8, Help- F1<br/>
9, Line delete -Ctrl+Y<br/>
10, Debug-F7<br/>
</h5>

<h2 className="mt-4 mh2">These are the c programming shortcut keys.
</h2>


<h1 className="mt-5">  </h1>
<div className="back">
        <a href="/c-identifier">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/c-first-program">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Cshortkeys;